import React from 'react';
import CustomButton from 'components/customButton';
import {Field, Form, Formik} from 'formik';
import CustomTextArea from 'modules/purchase/PurchaseRegistration/customTextArea';
import useReplyMSG from './hooks/useReplyMSG';
import {useLocation} from 'react-router-dom';
interface SendReplyMSGProps {
  post_type: string;
  profile_type: string;
  post: string;
  setIsOpen: (isOpen: boolean) => void;
  buyers?: boolean;
}
const SendReplyMSG = ({
  post_type,
  profile_type,
  post,
  buyers,
  setIsOpen,
}: SendReplyMSGProps) => {
  const {isLoading, mutate} = useReplyMSG();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');

  return (
    <div className="bg-white w-[90%] flex flex-col rounded-lg p-4">
      <Formik
        initialValues={{
          text: '',
        }}
        onSubmit={(values, actions) => {
          mutate({
            text: values.text,
            first_app: isFarm ? 'FARM' : 'MARKET',
            second_app: profile_type === 'market' ? 'MARKET' : 'FARM',
            post: post,
            post_type: post_type,
            clearInput: actions.resetForm,
          });
        }}
      >
        {({resetForm}) => (
          <Form className="flex flex-col  px-4 gap-6 ">
            <div className="w-full flex justify-between items-center">
              {buyers ? (
                <h4 className="font-medium text-black">ارسال پیام به خریدار</h4>
              ) : (
                <h4 className="font-medium text-black">
                  ارسال پیام به فروشنده
                </h4>
              )}
              <button
                type="button"
                onClick={() => {
                  resetForm();
                  setIsOpen(false);
                }}
              >
                <span className="icon-close text-[12px]" />
              </button>
            </div>
            <div>
              <Field
                type="textarea"
                name="text"
                row={10}
                as={CustomTextArea}
                placeholder="پیام"
                className="w-full h-[150px] text-sm text-gray-6 text-[16px] border rounded-2xl  bg-gray-1 resize-none focus:outline-none p-4"
              />
            </div>
            <div className="flex w-full gap-4 justify-evenly h-[10%]">
              <CustomButton
                isLoading={isLoading}
                title="ارسال"
                type="submit"
                className="w-[40%] !bg-primary border-1  !text-white"
              />
              <CustomButton
                onClick={() => {
                  resetForm();
                  setIsOpen(false);
                }}
                title="انصراف"
                className="w-[40%] !bg-white !text-black "
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SendReplyMSG;
